export default "__VITE_PUBLIC_ASSET__c86aae38__"